var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChat = function SvgChat(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M19 2.25A3.75 3.75 0 0 1 22.75 6v6A3.75 3.75 0 0 1 19 15.75h-.25V16A3.75 3.75 0 0 1 15 19.75h-2.536l-.899 1.797c-.644 1.29-2.485 1.29-3.13 0l-.899-1.797H5A3.75 3.75 0 0 1 1.25 16v-6A3.75 3.75 0 0 1 5 6.25h.25V6A3.75 3.75 0 0 1 9 2.25zM5 7.75A2.25 2.25 0 0 0 2.75 10v6A2.25 2.25 0 0 0 5 18.25h3a.75.75 0 0 1 .617.324l.054.091 1.105 2.211a.25.25 0 0 0 .448 0l1.105-2.211A.75.75 0 0 1 12 18.25h3A2.25 2.25 0 0 0 17.25 16v-6A2.25 2.25 0 0 0 15 7.75zm4-4A2.25 2.25 0 0 0 6.75 6v.25H15A3.75 3.75 0 0 1 18.75 10v4.25H19A2.25 2.25 0 0 0 21.25 12V6A2.25 2.25 0 0 0 19 3.75zM7 12a1 1 0 1 1 0 2 1 1 0 0 1 0-2m3 0a1 1 0 1 1 0 2 1 1 0 0 1 0-2m3 0a1 1 0 1 1 0 2 1 1 0 0 1 0-2"
  })));
};
export default SvgChat;